const productList = [
    {
        no: 0,
        title: 'Etc',
        products: [
            {
                no: 0,
                title: 'Etc'
            }
        ]
    },
    {
        no: 1,
        title: 'Endpoint Protection',
        products: [
            {
                no: 0,
                title: 'TACHYON Endpoint Security 5.0'
            },
            {
                no: 1,
                title: 'TACHYON Endpoint Security 5.5'
            },
            {
                no: 2,
                title: 'TACHYON Server Security 5.0'
            },
            {
                no: 3,
                title: 'TACHYON White Security 5.0'
            },
            {
                no: 4,
                title: 'TACHYON Linux Security 5.0'
            }
        ]
    },
    {
        no: 2,
        title: 'Central Management',
        products: [
            {
                no: 0,
                title: 'TACHYON Total Security 3.5'
            },
            {
                no: 1,
                title: 'TACHYON Patch Manager System 3.0'
            },
            {
                no: 2,
                title: 'TACHYON Relay Server 3.0'
            }
        ]
    },
    {
        no: 3,
        title: 'Security Utility',
        products: [
            {
                no: 0,
                title: 'TACHYON File Wiper 1.0'
            },
            {
                no: 1,
                title: 'TACHYON Disk Wiper 1.0'
            },
            {
                no: 2,
                title: 'TACHYON File Crptor 1.0'
            }
        ]
    },
    {
        no: 4,
        title: 'Utility',
        products: [
            {
                no: 0,
                title: 'TACHYON Hash Viewer 1.0'
            }
        ]
    },
    {
        no: 5,
        title: 'Security SDK',
        products: [
            {
                no: 0,
                title: 'TACHYON Core Suite 1.0'
            }
        ]
    }
]

const MailProductSelectList = class MailProductSelectList {
    constructor() {
        productList.forEach((value)=> {
            this.list.push(value);
        })
    }

    list = [];

    get items() {
        return this.list;
    }

}

export default MailProductSelectList;